<template>
  <el-form class="money-cn-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="refCid">
      <template slot="label">
        <span class="require-flag">*</span>
        关联金额
      </template>
      <el-select v-model="control.refCid" style="width: 100%;">
        <el-option
          v-for="control in canRefControls"
          :key="control._cid"
          :label="control.name"
          :value="control._cid"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "money-cn-control",
  props: {
    control: Object,
    sheet: Object
  },
  computed: {
    canRefControls() {
      return (this.sheet.controls || []).filter(ctl =>
        ["money", "gather", "calc"].includes(ctl._type)
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
